export default __webpack_public_path__ + "static/media/graphene.cde32a16.svg";